// extracted by mini-css-extract-plugin
export var mute = "video-module--mute--bffed";
export var wrapper = "video-module--wrapper--8de13";